import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styles: [],
    standalone: false
})
export class LogoutComponent implements OnInit {
  public errorMessage: string;

  public constructor(private readonly titleService: Title, private readonly userService: UserService) { }

  public ngOnInit(): void {
    this.titleService.setTitle("Sign Out");

    this.userService.logout();
  }
}
